import DataObject from "@mui/icons-material/DataObject";
import { ToggleButton, Tooltip } from "@mui/material";
import { useCallback } from "react";
import { usePopover } from "../../../utils/hooks/use-popover";
import { MergeTagLookup } from "./merge-tag-lookup";

import type { TagGroup } from "./types";
import type { SxProps, Theme } from "@mui/material";
import type { FC } from "react";

interface Props {
  disabled?: boolean;
  onSelection: (tagId: string) => void;
  filterTags: (x: string) => TagGroup;
  buttonStyle?: SxProps<Theme>;
}

export const TokenPickerV2: FC<Props> = ({ disabled, onSelection, filterTags, buttonStyle }) => {
  const popover = usePopover<HTMLButtonElement>();

  const handleSelection = useCallback(
    (tagId: string): void => {
      if (!tagId) return;

      onSelection(`{{${tagId}}}`);
      popover.handleClose();
    },
    [onSelection, popover],
  );

  return (
    <>
      <Tooltip title="Merge tags">
        <span>
          <ToggleButton
            data-analytics-id={`lexical-toolbar-merge-tag-picker`}
            data-testid="add-token"
            onMouseDown={(e) => e.preventDefault()}
            onClick={popover.handleToggle}
            value="token"
            sx={buttonStyle || { border: "none", borderRadius: 0 }}
            disabled={disabled}
            ref={popover.anchorRef}
          >
            <DataObject fontSize="small" />
          </ToggleButton>
        </span>
      </Tooltip>
      <MergeTagLookup
        open={popover.open}
        anchorEl={popover.anchorRef?.current}
        onClose={popover.handleClose}
        filterTags={filterTags}
        onSelection={handleSelection}
      />
    </>
  );
};
